/**
 * UI copy.
 *
 * Polish is the shipped locale; the structure is deliberately a flat dictionary
 * keyed by stable identifiers so an English (or any other) locale can be added
 * without touching a single component.
 */

export type Locale = 'pl';

export const messages = {
  pl: {
    'app.title': 'API Hub',
    'app.subtitle': 'Panel administracyjny',

    'nav.overview': 'Przegląd',
    'nav.dashboard': 'Pulpit',
    'nav.requests': 'Dziennik żądań',
    'nav.usage': 'Zużycie i koszty',
    'nav.audit': 'Dziennik audytu',

    'nav.providers': 'Dostawcy',
    'nav.providerList': 'Dostawcy',
    'nav.connections': 'Połączenia',
    'nav.upstreamMcp': 'Serwery MCP upstream',

    'nav.catalog': 'Katalog',
    'nav.services': 'Usługi',
    'nav.operations': 'Operacje',
    'nav.modelAliases': 'Aliasy modeli',
    'nav.openapiImport': 'Import OpenAPI',
    'nav.knowledge': 'Źródła wiedzy',
    'nav.catalogVersions': 'Wersje katalogu',

    'nav.clients': 'Klienci',
    'nav.clientApps': 'Aplikacje klienckie',
    'nav.hubKeys': 'Klucze Hub',
    'nav.developerTokens': 'Tokeny deweloperskie',

    'nav.agents': 'Agenci',
    'nav.toolsets': 'Zestawy narzędzi MCP',
    'nav.mcpPreview': 'Podgląd MCP',
    'nav.packs': 'Pakiety integracyjne',

    'nav.operationsSection': 'Administracja',
    'nav.testConsole': 'Konsola testowa',
    'nav.users': 'Użytkownicy i role',
    'nav.apiReference': 'Dokumentacja API',
    'nav.settings': 'Ustawienia',

    'common.create': 'Utwórz',
    'common.save': 'Zapisz',
    'common.cancel': 'Anuluj',
    'common.delete': 'Usuń',
    'common.edit': 'Edytuj',
    'common.refresh': 'Odśwież',
    'common.close': 'Zamknij',
    'common.copy': 'Kopiuj',
    'common.copied': 'Skopiowano',
    'common.search': 'Szukaj',
    'common.loading': 'Wczytywanie…',
    'common.none': 'brak',
    'common.unknown': 'nieznane',
    'common.yes': 'tak',
    'common.no': 'nie',
    'common.environment': 'Środowisko',
    'common.actions': 'Akcje',
    'common.status': 'Status',
    'common.name': 'Nazwa',
    'common.created': 'Utworzono',
    'common.never': 'nigdy',

    'auth.signIn': 'Zaloguj się',
    'auth.email': 'Adres e-mail',
    'auth.login': 'Login lub e-mail',
    'auth.code': 'Kod z wiadomości e-mail',
    'auth.confirmCode': 'Potwierdź kod',
    'users.username': 'Login',
    'auth.password': 'Hasło',
    'auth.signOut': 'Wyloguj',
    'auth.mustChangePassword': 'Zmień hasło, aby kontynuować.',
    'auth.changePassword': 'Zmiana hasła',
    'auth.currentPassword': 'Bieżące hasło',
    'auth.newPassword': 'Nowe hasło',

    'secret.shownOnce': 'Ta wartość jest pokazywana tylko raz. Skopiuj ją teraz.',
    'secret.masked': 'Sekret jest zaszyfrowany i nie może zostać ponownie wyświetlony.',
  },
} as const;

export type MessageKey = keyof (typeof messages)['pl'];

let activeLocale: Locale = 'pl';

export function setLocale(locale: Locale): void {
  activeLocale = locale;
}

export function t(key: MessageKey): string {
  return messages[activeLocale][key] ?? key;
}
